import React from 'react';
import { Link } from 'react-router-dom';
import './CablesHome.css';

const CablesHome = () => {
  // Cable categories with actual images from your folder
  const cableCategories = [
    { 
      name: 'Armoured Cables', 
      image: '/images/products/armoured-cable.jpg',
      description: 'Steel wire armoured for industrial use', 
      link: '/products#armoured' 
    },
    { 
      name: 'Submersible Cables', 
      image: '/images/products/submersible-cables.jpg',
      description: 'Water-resistant for borehole pumps', 
      link: '/products#submersible' 
    },
    { 
      name: 'Domestic Cables', 
      image: '/images/products/domestic-cables.jpg',
      description: 'House wiring, lighting circuits', 
      link: '/products#domestic' 
    },
    { 
      name: 'Welding Cables', 
      image: '/images/products/welding-cable.jpg',
      description: 'Flexible cables for welding', 
      link: '/products#welding' 
    },
    { 
      name: 'Flexible Cables', 
      image: '/images/products/flexible-cables.jpg',
      description: 'For industrial applications', 
      link: '/products#flexible' 
    },
    { 
      name: 'ABC Cables', 
      image: '/images/products/abc.JPG',
      description: 'Aerial bundled for overhead', 
      link: '/products#abc' 
    },
    { 
      name: 'Copper Cables', 
      image: '/images/products/copper-single.jpg',
      description: 'High conductivity copper', 
      link: '/products#copper' 
    },
    { 
      name: 'Aluminium Cables', 
      image: '/images/products/aluminium-single.jpg',
      description: 'Lightweight and economical', 
      link: '/products#aluminium' 
    }
  ];

  // Featured products with images
  const featuredProducts = [
    { name: 'Armoured Cable', image: '/images/products/armoured-cable.jpg' },
    { name: 'Copper Cable', image: '/images/products/copper-single.jpg' },
    { name: 'Submersible Cable', image: '/images/products/submersible-cables.jpg' },
    { name: 'Welding Cable', image: '/images/products/welding-cable.jpg' }
  ];

  // Key features with ISO certification highlighted
  const features = [
    { icon: '🔴', title: '99.9% Pure Copper', desc: 'EC grade copper for maximum conductivity' },
    { icon: '🔥', title: 'Fire Retardant', desc: 'FRLS PVC for enhanced safety' },
    { icon: '🏭', title: 'In-house Manufacturing', desc: 'Complete control from wire drawing to packing' },
    { icon: '🔬', title: 'Modern Test Lab', desc: 'Rigorous quality testing for every batch' },
    { icon: '✓', title: 'KEBS Approved', desc: 'All products meet Kenya standards' },
    { icon: '📦', title: 'Bulk Supply', desc: 'Contractor and project pricing available' }
  ];

  // ISO Certification highlights
  const certifications = [
    { icon: '🏅', title: 'ISO 9001:2015 Certified', desc: 'International quality management system' },
    { icon: '✓', title: 'KEBS Approved', desc: 'Kenya Bureau of Standards certified' },
    { icon: '🔬', title: 'In-house Laboratory', desc: 'Regular testing and quality control' },
    { icon: '🌍', title: 'Export Quality', desc: 'Meeting international standards' }
  ];

  // Applications
  const applications = [
    { icon: '🏗️', title: 'Construction', desc: 'Armoured & domestic cables for buildings' },
    { icon: '💧', title: 'Water Projects', desc: 'Submersible cables for boreholes' },
    { icon: '🏭', title: 'Industrial', desc: 'Flexible & control cables for factories' },
    { icon: '🚗', title: 'Automotive', desc: 'Specialized cables for vehicles' },
    { icon: '⚡', title: 'Power Distribution', desc: 'Overhead conductors & LV cables' },
    { icon: '🏢', title: 'Commercial', desc: 'Wiring for offices and malls' }
  ];

  return (
    <div className="cables-home">
      {/* Hero Section */}
      <section className="cables-hero">
        <div className="container">
          <div className="hero-badge-container">
            <span className="hero-badge">ISO 9001:2015 CERTIFIED</span>
          </div>
          <h1>Masai Cables Limited</h1>
          <p className="hero-tagline">Building Stronger Connections</p>
          <p className="hero-description">
            Kenya's premier ISO 9001:2015 certified cable manufacturer. From power distribution to house wiring, 
            we deliver internationally certified quality cables for every application.
          </p>
          <div className="hero-stats">
            <div className="hero-stat">
              <span className="stat-value">160 MT</span>
              <span className="stat-label">Copper Capacity</span>
            </div>
            <div className="hero-stat">
              <span className="stat-value">200 MT</span>
              <span className="stat-label">Aluminium Capacity</span>
            </div>
            <div className="hero-stat">
              <span className="stat-value">ISO 9001</span>
              <span className="stat-label">Certified</span>
            </div>
            <div className="hero-stat">
              <span className="stat-value">13+</span>
              <span className="stat-label">Cable Types</span>
            </div>
          </div>
          <div className="hero-buttons">
            <Link to="/products" className="btn btn-primary">View Products</Link>
            <Link to="/catalogue" className="btn btn-outline">Full Catalogue</Link>
          </div>
        </div>
      </section>

      {/* ISO Certification Banner */}
      <section className="iso-banner">
        <div className="container">
          <div className="iso-content">
            <span className="iso-icon">🏅</span>
            <div className="iso-text">
              <h3>ISO 9001:2015 Certified Company</h3>
              <p>Our quality management system meets international standards, ensuring consistent quality across all our cable products.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Products Preview */}
      <section className="featured-preview">
        <div className="container">
          <h2>Featured Products</h2>
          <div className="preview-grid">
            {featuredProducts.map((product, index) => (
              <div className="preview-card" key={index}>
                <img src={product.image} alt={product.name} />
                <div className="preview-overlay">
                  <h4>{product.name}</h4>
                  <Link to="/catalogue" className="preview-link">View →</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Certifications Grid */}
      <section className="certifications-section">
        <div className="container">
          <h2>Our Certifications</h2>
          <div className="cert-grid">
            {certifications.map((cert, index) => (
              <div className="cert-card" key={index}>
                <div className="cert-icon">{cert.icon}</div>
                <h4>{cert.title}</h4>
                <p>{cert.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Category Grid with Images */}
      <section className="cables-categories">
        <div className="container">
          <h2>Our Cable Range</h2>
          <p className="section-subtitle">ISO certified cables for every electrical need</p>
          <div className="categories-grid">
            {cableCategories.map((cat, index) => (
              <Link to={cat.link} className="category-card" key={index}>
                <div className="category-image">
                  <img src={cat.image} alt={cat.name} />
                </div>
                <h3>{cat.name}</h3>
                <p>{cat.description}</p>
                <span className="category-link">Learn More →</span>
              </Link>
            ))}
          </div>
          <div className="view-all-container">
            <Link to="/products" className="btn btn-secondary">View All Products</Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2>Why Choose Masai Cables?</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Applications Section */}
      <section className="applications-section">
        <div className="container">
          <h2>Applications</h2>
          <p className="section-subtitle">Trusted across multiple industries</p>
          <div className="applications-grid">
            {applications.map((app, index) => (
              <div className="application-card" key={index}>
                <div className="app-icon">{app.icon}</div>
                <h3>{app.title}</h3>
                <p>{app.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quality Assurance Section */}
      <section className="quality-section">
        <div className="container">
          <div className="quality-content">
            <h2>Uncompromising Quality</h2>
            <div className="quality-points">
              <div className="quality-point">
                <span className="check">✓</span>
                <div>
                  <h4>ISO 9001:2015 Certified</h4>
                  <p>Our entire manufacturing process follows strict ISO quality standards</p>
                </div>
              </div>
              <div className="quality-point">
                <span className="check">✓</span>
                <div>
                  <h4>In-house Testing Laboratory</h4>
                  <p>Regular testing ensures every batch meets specifications</p>
                </div>
              </div>
              <div className="quality-point">
                <span className="check">✓</span>
                <div>
                  <h4>KEBS Approved Products</h4>
                  <p>All cables meet Kenya Bureau of Standards requirements</p>
                </div>
              </div>
              <div className="quality-point">
                <span className="check">✓</span>
                <div>
                  <h4>International Standards</h4>
                  <p>Manufactured to IEC, BS, and KS standards</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cables-cta">
        <div className="container">
          <h2>Need Quality Cables for Your Project?</h2>
          <p>Contact us for competitive pricing on bulk orders</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-light">Request Quote</Link>
            <Link to="/catalogue" className="btn btn-outline-light">Download Catalogue</Link>
          </div>
          <p className="iso-note">ISO 9001:2015 Certified • KEBS Approved</p>
        </div>
      </section>
    </div>
  );
};

export default CablesHome;